import React from "react"
import Box from "@mui/material/Box"

export default function SiteHeaderSpacer() {
  return <Box sx={{ height: 65, width: "100%" }} />
}
